export default Object.freeze({
    STATUS_AWAITING_CONTRACT: '1',
    STATUS_AWAITING_SIGNATURE: '2',
    STATUS_AWAITING_PAYMENT: '3',
    STATUS_AWAITING_INVOICE: '4',
    STATUS_AWAITING_RETURN: '5',
    STATUS_ACTIVE: '6',
    STATUS_FINISHED: '7',
    STATUS_CANCELED: '8',
    STATUS_AWAITING_RELEASE: '9',
    STATUS_AWAITING_CONFIRMATION_PJ: '10',
    STATUS_AWAITING_DEADLINE_CHANGE: '11',
    STATUS_OVERDUE: '12',
    STATUS_AWAITING_ITEM_CHANGE: '13',
    STATUS_AWAITING_SHIPPING: '14',
    STATUS_AWAITING_DELIVERY: '15',
    STATUS_AWAITING_SEND_CONFIRMATION: '16',
    STATUS_AWAITING_RECEIPT: '17',
    STATUS_AWAITING_RETURN_INVOICE: '18',
    STATUS_AWAITING_RETURN_ITEMS: '19',
    STATUS_AWAITING_CONFIRM: '20',
    STATUS_AWAITING_REGISTER_INSTALL: '21',
    STATUS_FINISHED_WITH_PENDENCY: '22',
    STATUS_AWAITING_RECEIPT_HEADQUARTERS: '23',
});